<template>
  <div>
    <div class="topbar-container">
      <div class="logo-box">
        <img
          :src="require('../../../../assets/img/logo-white.svg')"
          alt="Arnergy Logo"
        />
      </div>
      <div class="right-box">
        <p class="help-text">
          For help please call us on
          <span class="bolden">07002288888</span>/<span class="bolden"
            >08002288888</span
          >
          or email us at <span class="bolden">support@arnergy.com</span>
        </p>
        <div class="v-divider"></div>
        <div class="user-details">
          <p class="name bolden">
            {{
              this.getUserSession !== null
                ? this.getUserSession.firstname +
                  " " +
                  this.getUserSession.lastname.toUpperCase()
                : ""
            }}
          </p>
          <p class="email sub-text">
            {{ this.getUserSession !== null ? this.getUserSession.email : "" }}
          </p>
        </div>
        <img
          :src="require('../../../../assets/img/logout.svg')"
          alt="Logout button"
          :style="{ cursor: 'pointer' }"
          @click="logout"
        />
        <a
          class="faq"
          href="https://onboarding-faq.netlify.app/homepage/"
          target="_blank"
          >Need Help?</a
        >
      </div>
    </div>
    <!-- Mobile Top Bar -->
    <div class="mobile-top-bar" v-if="isMobile">
      <h2>My Existing Devices</h2>
      <button class="menu-toggle" @click="toggleDrawer">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.25 8C14.25 8.19891 14.171 8.38968 14.0303 8.53033C13.8897 8.67098 13.6989 8.75 13.5 8.75H2.5C2.30109 8.75 2.11032 8.67098 1.96967 8.53033C1.82902 8.38968 1.75 8.19891 1.75 8C1.75 7.80109 1.82902 7.61032 1.96967 7.46967C2.11032 7.32902 2.30109 7.25 2.5 7.25H13.5C13.6989 7.25 13.8897 7.32902 14.0303 7.46967C14.171 7.61032 14.25 7.80109 14.25 8ZM2.5 4.75H13.5C13.6989 4.75 13.8897 4.67098 14.0303 4.53033C14.171 4.38968 14.25 4.19891 14.25 4C14.25 3.80109 14.171 3.61032 14.0303 3.46967C13.8897 3.32902 13.6989 3.25 13.5 3.25H2.5C2.30109 3.25 2.11032 3.32902 1.96967 3.46967C1.82902 3.61032 1.75 3.80109 1.75 4C1.75 4.19891 1.82902 4.38968 1.96967 4.53033C2.11032 4.67098 2.30109 4.75 2.5 4.75ZM13.5 11.25H2.5C2.30109 11.25 2.11032 11.329 1.96967 11.4697C1.82902 11.6103 1.75 11.8011 1.75 12C1.75 12.1989 1.82902 12.3897 1.96967 12.5303C2.11032 12.671 2.30109 12.75 2.5 12.75H13.5C13.6989 12.75 13.8897 12.671 14.0303 12.5303C14.171 12.3897 14.25 12.1989 14.25 12C14.25 11.8011 14.171 11.6103 14.0303 11.4697C13.8897 11.329 13.6989 11.25 13.5 11.25Z"
            fill="white"
          />
        </svg>
      </button>
    </div>

    <!-- Main Content -->
    <div class="solar-dashboard">
      <div class="content">
        <div class="left-panel" v-show="!isDrawerOpen">
          <h1>Enhance Your Solar Experience</h1>
          <p>
            Take your solar experience to the next level: Enjoy increased energy
            efficiency and uninterrupted power supply.
          </p>
          <div class="add-device">
            <div class="add-device-card" @click="existingUserOnboardingStart">
              <div class="add-icon">+</div>
              <h3>Add New Device</h3>
              <p>Expand your solar capabilities with a new device</p>
            </div>
          </div>
        </div>

        <div class="right-panel" :class="{ open: isDrawerOpen }">
          <h2>My Existing Devices</h2>
          <Accordion
            v-for="(device, index) in devices"
            :key="index"
            :title="device.product"
            v-model="device.isOpen"
          >
            <template #content>
              <div class="device-details">
                <p class="device-id">Device ID: {{ device.DeviceID }}</p>
                <hr />
                <div>
                  <p class="device-title">Total Amount</p>
                  <p class="device-value">
                    &#8358;
                    {{
                      Intl.NumberFormat("en-US").format(+device.totalpayment) ||
                      0
                    }}
                  </p>
                </div>
                <hr />
                <div>
                  <p class="device-title">Monthly Payment</p>
                  <p class="device-value">
                    &#8358;
                    {{
                      Intl.NumberFormat("en-US").format(
                        +device.monthlypayment
                      ) || 0
                    }}
                  </p>
                </div>
              </div>
            </template>
          </Accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "../../../../router";
import Accordion from "./Accordion.vue";

export default {
  name: "ExistingUser",
  computed: {
    ...mapGetters(["getUserSession"]),
  },
  components: {
    Accordion,
  },
  data() {
    return {
      showDropdown: false,
      isDrawerOpen: false,
      isMobile: window.innerWidth <= 768,
      devices: [],
    };
  },

  methods: {
    ...mapActions(["setUserSession"]),
    logout() {
      this.setUserSession(null);
      setTimeout(() => {
        router.push("/auth/login");
      }, 100);
    },

    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },

    init() {
      this.fetchDeviceData();
    },

    async fetchDeviceData() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let url = "/onboardingstate/user-devices-info";

      const response = await HTTP.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
        },
      });
      try {
        this.devices = response.data.map((device) => ({
          ...device,
          isOpen: false,
        }));
      } catch (error) {
        this.showErrorMsg({ message: "Error occurred at our end!" });
      }
    },

    async existingUserOnboardingStart() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let url = "/onboardingstate/start-add-device-onboarding";
      try {
        const response = await HTTP.post(
          url,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
            },
          }
        );

        if (response.data.currentPageName == "Start") {
          router.push("/onboarding");
        } else if (response.data.currentPageName == "IPPSelectDevice") {
          router.push("/onboarding/ipp");
        } else if (
          response.data.currentPageName == "OnboardIPPPaymentSummary"
        ) {
          router.push("/onboarding/ipp/payment-summary");
        } else if (
          // response.data.currentPageName == "BVNCheck" ||
          response.data.currentPageName == "KYCUpload"
        ) {
          router.push("/onboarding/contract-upload");
        } else {
          router.push("/onboarding");
        }
      } catch (error) {
        this.showErrorMsg({ message: "Error occurred at our end!" });
      }
    },

    navigateToOnboarding() {
      router.push("/onboarding");
    },
  },

  beforeMount() {
    const jwtToken = this.$route.query.jwt_token;
    if (jwtToken) {
      localStorage.setItem("appUserToken", jwtToken);
    }
  },

  async mounted() {
    this.init();
    window.addEventListener("resize", this.checkScreenSize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
};
</script>

<style scoped>
@import "../../../../assets/scss/_reduced_variables.scss";
/* Top Bar Styling Begins */
h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.topbar-container {
  height: 100px;
  background: #0892d0;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding: 33px 70px;
  justify-content: space-between;
  /* margin-bottom: 30px; */
}

.logo-box img {
  max-width: 160px;
}

.right-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  font-size: 16px;
}

.right-box .help-text {
  width: 45%;
  text-align: right;
  margin-right: 40px;
  line-height: 22px;
}

.v-divider {
  height: 100%;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  margin-right: 40px;
}

.bolden {
  font-weight: 700;
}

.user-details {
  margin-right: 60px;
}

.user-details .sub-text {
  font-size: 12px;
  line-height: 16px;
}

.faq {
  margin-left: 20px;
  border: none;
  background: #0892d0;
  color: #ffffff;
}

@media screen and (max-width: 430px) {
  .topbar-container {
    padding-left: 2rem;
  }

  .user-details,
  .help-text {
    display: none;
  }

  .v-divider {
    margin-left: 4rem;
  }
}
/* Top Bar Styling Ends */

.content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.left-panel {
  padding: 65px;
  width: 45%;
}

.left-panel h1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
  color: #0892d0;
  margin-bottom: 2.1rem;
}

.left-panel p {
  font-size: 18px;
  font-weight: 500;
  color: #666666;
}

.add-device-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 20px;
  padding: 35px;
  cursor: pointer;
  transition: 0.3s;
  width: 78%;
  background-color: #ffffff;
  margin-top: 40px;
}

.add-icon {
  font-size: 50px;
  width: 32px;
  height: 32px;
  color: #1a93c9;
  margin-bottom: 30px;
}

.add-device-card h3 {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
}

.add-device-card p {
  font-size: 18px;
  color: #666666;
  text-align: center;
}

.right-panel {
  background-color: #0c425a;
  color: #ffffff;
  padding: 20px 40px;
  transition: transform 0.3s ease;
  width: 35%;
  height: 100vh;
}

.device-id {
  font-weight: 400;
  line-height: 20px;
  font-size: 14px;
  font-family: "DM Sans";
}

.device-title {
  font-weight: 400;
  line-height: 20px;
  font-size: 14px;
  font-family: "DM Sans";
}

.device-value {
  font-weight: 600;
  line-height: 20px;
  font-size: 16px;
  font-family: "DM Sans";
}

/* Mobile styles */
@media (max-width: 768px) {
  .add-device-card {
    width: 100%;
    padding: 20px;
    align-items: flex-start;
    text-align: left;
    margin: 20px 0;
  }

  .add-icon {
    align-self: flex-start;
    margin-bottom: 12px;
  }

  .add-device-card h3 {
    width: 100%;
    text-align: left;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .add-device-card p {
    width: 100%;
    text-align: left;
    font-size: 16px;
    padding: 0;
    margin: 0;
  }
}

/* Mobile Styles */
@media (max-width: 768px) {
  .mobile-top-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #0c425a;
    height: 52px;
  }

  .mobile-top-bar h2 {
    font-size: 16px;
    color: #ffffff;
  }

  .content {
    flex-direction: column;
  }

  .left-panel {
    width: 100% !important;
    padding: 20px;
    display: flex !important;
    flex-direction: column;
  }

  .left-panel p {
    font-weight: 400;
  }

  .add-icon {
    margin-bottom: 37px;
  }

  .right-panel {
    position: fixed;
    top: 138px;
    right: 0;
    bottom: 0;
    width: 80%;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 100;
    background-color: #0c425a;
    padding: 20px;
    margin-top: 14px;
  }

  .right-panel.open {
    transform: translateX(0);
    width: 90%;
  }
  .right-panel h2 {
    display: none;
  }

  .menu-toggle {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-left: 15px;
    margin-right: 15px;
  }
}

/* Add additional breakpoint for very small devices */
@media screen and (max-width: 375px) {
  .left-panel h1 {
    font-size: 22px !important;
  }

  .left-panel p {
    font-size: 14px !important;
  }

  .add-device-card {
    padding: 12px;
  }

  .add-device-card h3 {
    font-size: 16px;
  }

  .add-device-card p {
    font-size: 14px;
  }
}

/* Add styles for medium-sized devices */
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .left-panel {
    width: 50% !important;
    padding: 30px !important;
  }

  .left-panel h1 {
    font-size: 28px;
  }

  .add-device-card {
    width: 100%;
    max-width: 335px;
  }
}

/* Small mobile devices */
@media (max-width: 375px) {
  .add-device-card {
    padding: 16px;
  }

  .add-device-card h3 {
    font-size: 16px;
  }

  .add-device-card p {
    font-size: 14px;
  }
}
/* Mobile Styles */
@media screen and (max-width: 430px) {
  .topbar-container {
    padding-left: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/existingUser/index.vue